import React from 'react';

import { Th, useTheme, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { ArrowDown, ArrowUp } from 'assets/assetsV1/iconComponents';
import { Sort } from 'assets/assetsV1/iconComponents/Sort';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledTh = styled(Th)`
  text-transform: inherit;
  padding: 8px 12px;
  border: none;
  &:first-of-type {
    border-radius: 4px 0 0 0;
  }

  &:last-of-type {
    border-radius: 0 4px 0 0;
  }
`;
const SortOption = styled.span`
  flex: 0 0 auto;
  margin-left: auto;
`;

const SORT_ORDERS = {
  ASC: 'ASC',
  DESC: 'DESC',
};

const GoalsTableHeaderCell = ({
  withSorting = false,
  sortOrder = SORT_ORDERS.ASC,
  children,
  width,
  textProps = {},
  ...props
}) => {
  const theme = useTheme();

  const renderSortIcon = () => {
    if (!withSorting) return null;

    if (sortOrder === SORT_ORDERS.ASC)
      return <ArrowUp sx={{ cursor: 'pointer' }} color={theme.colors.secondary['666666']} boxSize="24px" />;

    if (sortOrder === SORT_ORDERS.DESC)
      return <ArrowDown sx={{ cursor: 'pointer' }} color={theme.colors.secondary['666666']} boxSize="24px" />;

    return <Sort sx={{ cursor: 'pointer' }} color={theme.colors.secondary['666666']} boxSize="20px" />;
  };

  return (
    <StyledTh width={width} {...props}>
      <Flex>
        <TextBodyMedium color={theme.colors.text.g1} sx={{ flex: '1 1 auto' }} {...textProps}>
          {children}
        </TextBodyMedium>
        <SortOption>{renderSortIcon()}</SortOption>
      </Flex>
    </StyledTh>
  );
};

export { GoalsTableHeaderCell };
